import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import { BootstrapVue, IconsPlugin } from "bootstrap-vue";
import initShowToastError from "./init/toastError";
import initTrackEvent from "./init/trackEvent";

import "./assets/main.scss";

Vue.use(BootstrapVue);
Vue.use(IconsPlugin);

initShowToastError(Vue);
initTrackEvent(Vue);

Vue.config.productionTip = false;

export let app = {};

app = new Vue({
  router,
  render: (h) => h(App),
}).$mount("#app");
